import type { CampaignLogoStyles } from '~/ui/campaign-logo';
import { tw } from '~/utils';

const box = tw(
  'mx-auto mb-4 flex aspect-square h-full max-h-[114px] w-full max-w-[114px] items-center justify-center overflow-hidden'
);
const img = tw('h-full w-full object-contain');

export const campaignLogoStyles = tw<CampaignLogoStyles>({
  box: {
    shop: box,
    offer: box,
  },
  img,
});

export const favoriteCampaignLogoStyles = tw<CampaignLogoStyles>({
  box: {
    shop: 'grid h-[114px] w-[114px] place-content-center',
    offer: '', // オファーはお気に入り登録できないので不要
  },
  img,
});
